import { all } from 'redux-saga/effects';

import authenSaga from './authen-saga';
import masterSaga from './master';

function* rootSaga() {
    yield all([
        ...authenSaga,
        ...masterSaga,
    ])
}

export default rootSaga;